<xemex-card-grid>
  <xemex-card [title]="'devices.detailTabs.alarms.label' | translate">
    <div class="flex flex-col gap-4">
      <p class="text-sm text-text-secondary">
        {{ 'devices.alarms.settings.description' | translate }}
      </p>

      @if (alarmSettingsForbidden()) {
        <p class="text-sm text-text-secondary">
          {{ 'devices.alarms.settings.noAccess' | translate }}
        </p>
      } @else {
        @if (loadError()) {
          <div class="flex items-center gap-2 rounded-xl bg-status-error p-3 text-error">
            <mat-icon>error_outline</mat-icon>
            <span>{{ 'devices.alarms.settings.loadError' | translate }}</span>
          </div>
        }

        <xemex-table
          [data]="visibleAlarmRows()"
          [columns]="columns"
          [loading]="initialLoading()"
          (toggleChange)="onToggleChange($event)"
        ></xemex-table>
      }

      @if (showResetSection()) {
        <div class="flex items-start justify-between gap-6 border-t pt-6">
          <div class="flex flex-col gap-1">
            <span class="text-sm font-medium">{{
              'devices.alarms.settings.resetDevice.label' | translate
            }}</span>
            <span class="text-sm text-text-secondary">{{
              'devices.alarms.settings.resetDevice.description' | translate
            }}</span>
          </div>
          <button
            mat-stroked-button
            color="warn"
            [disabled]="resetInProgress()"
            (click)="onResetDevice()"
          >
            {{ 'devices.alarms.settings.resetDevice.action' | translate }}
          </button>
        </div>
      }
    </div>
  </xemex-card>

  <div class="flex flex-col gap-6">
    <xemex-card [title]="'devices.alarms.settings.meterConfig.label' | translate">
      <div class="flex flex-col gap-4">
        <p class="text-sm text-text-secondary">
          {{ 'devices.alarms.settings.meterConfig.description' | translate }}
        </p>

        @if (meterConfigManagedByOwner()) {
          <xemex-detail-field [label]="'devices.alarms.settings.meterRole.label' | translate">
            {{ 'meterRoles.' + meterRoleDraft() | translate }}
          </xemex-detail-field>
          <xemex-detail-field
            [label]="'devices.alarms.settings.phaseCount.label' | translate"
          ></xemex-detail-field>
          <p class="text-sm text-text-secondary">
            {{ 'devices.alarms.settings.meterConfig.managedByOwner' | translate }}
          </p>
        } @else {
          <xemex-select-field [label]="'devices.alarms.settings.meterRole.label' | translate">
            <mat-select
              [value]="meterRoleDraft()"
              [disabled]="!canEditMeterRole()"
              [hideSingleSelectionIndicator]="true"
              (selectionChange)="onMeterRoleChange($event.value)"
            >
              <mat-select-trigger>{{
                'meterRoles.' + meterRoleDraft() | translate
              }}</mat-select-trigger>
              @for (role of meterRoleOptions; track role) {
                <mat-option [value]="role">
                  <div class="flex items-center gap-2 py-1">
                    <mat-icon class="text-text-muted">{{ meterRoleIcons[role] }}</mat-icon>
                    <div>
                      <div class="text-sm font-medium">{{ 'meterRoles.' + role | translate }}</div>
                      <div class="text-xs text-muted">
                        {{ 'meterRoles.descriptions.' + role | translate }}
                      </div>
                    </div>
                  </div>
                </mat-option>
              }
            </mat-select>
          </xemex-select-field>

          <xemex-select-field [label]="'devices.alarms.settings.phaseCount.label' | translate">
            <mat-select
              [value]="phaseCountDraft()"
              [disabled]="phaseCountSelectDisabled()"
              [hideSingleSelectionIndicator]="true"
              (selectionChange)="onPhaseCountChange($event.value)"
            >
              <mat-select-trigger>{{
                'phaseCounts.' + phaseCountDraft() | translate
              }}</mat-select-trigger>
              @for (value of phaseCountOptions; track value) {
                <mat-option [value]="value">
                  {{ 'phaseCounts.' + value | translate }}
                </mat-option>
              }
            </mat-select>
          </xemex-select-field>

          @if (phaseCountNotDetected()) {
            <p class="text-sm text-text-secondary">
              {{ 'devices.alarms.settings.phaseCount.notDetectedHint' | translate }}
            </p>
          }

          @if (phaseCountExhausted()) {
            <p class="text-sm text-text-secondary">
              {{ 'devices.alarms.settings.phaseCount.exhaustedHint' | translate }}
            </p>
            <xemex-text-button
              (click)="onResetPhaseCountDetection()"
              [disabled]="resettingPhaseCountDetection() || phaseCountSelectDisabled()"
            >
              {{ 'devices.alarms.settings.phaseCount.retryDetection' | translate }}
            </xemex-text-button>
          }
        }
      </div>
    </xemex-card>

    <xemex-pv-forecast-card
      [deviceDetail]="deviceDetail()"
      [partnerDefaultMeterRole]="partnerDefaultMeterRole()"
    />
  </div>
</xemex-card-grid>

@if (hasAnyUnsavedChanges()) {
  <div
    class="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 flex w-fit items-center gap-3 rounded-2xl border border-amber-300 bg-status-warning px-3 py-2 shadow-md"
  >
    <div class="flex items-center gap-1.5 text-sm text-amber-800">
      <mat-icon class="shrink-0 text-amber-500 !text-[16px] !w-4 !h-4">warning</mat-icon>
      <span>{{ 'devices.alarms.settings.unsavedChanges.message' | translate }}</span>
    </div>
    <div class="flex items-center gap-1">
      <xemex-text-button (click)="discardAll()" [disabled]="saving()">
        {{ 'devices.alarms.settings.unsavedChanges.discard' | translate }}
      </xemex-text-button>
      <xemex-filled-button (click)="saveAll()" [disabled]="saving()">
        {{ 'devices.alarms.settings.unsavedChanges.save' | translate }}
      </xemex-filled-button>
    </div>
  </div>
}
